function loadSurveyButtonAnimations() {
  const surveyButton = document.querySelector('.survey-button');

  if (window.sessionStorage.getItem('animate-survey-button') === 'no') {
    return;
  }

  window.gsap.set(surveyButton, {
    opacity: 0,
    y: -30,
  });

  window.gsap.to(surveyButton, {
    opacity: 1,
    y: 0,
    duration: 1.5,
    delay: 2,
    ease: 'Bounce.easeOut',
  });

  const timeline = window.gsap.timeline({
    delay: 8,
    repeat: -1,
    repeatDelay: 5,
  });

  timeline.to(surveyButton, {
    y: -20,
    duration: 1,
    ease: 'Power1.easeOut',
  });

  timeline.to(surveyButton, {
    y: 0,
    duration: 1.5,
    ease: 'Bounce.easeOut',
  });

  window.sessionStorage.setItem('animate-survey-button', 'no');
}
document.addEventListener('DOMContentLoaded', loadSurveyButtonAnimations);
